export const labelStatus = (status) => {
  switch (status) {
    case "A":
      return "Ativo";
    case "B":
      return "Inativo";
    default:
      return "Desconhecido";
  }
};

export const labelStatusColor = (status) => {
  switch (status) {
    case "A":
      return "success";
    case "B":
      return "error";
    default:
      return "warning";
  }
};

export const filterUsers = (users, filter) => {
  return users
    ? users?.filter((user) => {
        if (filter) {
          return (
            user.nome.toLowerCase().includes(filter.toLowerCase()) ||
            user.email.toLowerCase().includes(filter.toLowerCase())
          );
        }
        return true;
      })
    : [];
};
